(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function positionToothsaverRecommendations() {
    const form = document.querySelector('[data-section-type="product"] .product-form');
    if (!form) return;
    document.querySelectorAll('[data-section-type="product-recommendations"]').forEach(section => {
      const wrapper = section.closest('.shopify-section');
      if (!wrapper || wrapper.contains(form)) return;
      wrapper.classList.add('toothsaver-inline-recommendations');
      if (form.nextElementSibling !== wrapper) {
        form.insertAdjacentElement('afterend', wrapper);
        window.dispatchEvent(new Event('resize'));
      }
      const share = form.querySelector('.product-meta__share-buttons');
      if (share) wrapper.insertAdjacentElement('afterend', share);
    });
  }
  const observedToothsaverContainers = new WeakSet();
  function watchToothsaverRecommendations() {
    positionToothsaverRecommendations();
    const container = document.querySelector('[data-section-type="product"] .product-form')?.parentElement;
    if (container && !observedToothsaverContainers.has(container)) {
      observedToothsaverContainers.add(container);
      new MutationObserver(positionToothsaverRecommendations).observe(container, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchToothsaverRecommendations);
  } else {
    watchToothsaverRecommendations();
  }
  document.addEventListener('shopify:section:load', watchToothsaverRecommendations);

  } catch(e) { console.error(e); }
})();
})();
